import { WebStorageStateStore } from 'oidc-client-ts';

import type { AuthProviderProps } from 'react-oidc-context';

export { getAccessToken } from './tokenProvider';

export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_AUTH_AUTHORITY,
  client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
  scope: 'openid profile',
  redirect_uri: window.location.origin + window.location.pathname,
  post_logout_redirect_uri: window.location.origin,
  staleStateAgeInSeconds: 3600,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  onSigninCallback: () => {
    window.history.replaceState({}, '', window.location.pathname);
  },
};
